import React, { useMemo, useState } from 'react'
import ContentHeading from '../../../components/layout/content/ContentHeading'
import { useTranslation } from 'react-i18next';
import StepperCustom from '../../../components/step/Stepper';
import { Grid, MenuItem, Typography } from '@mui/material';
import { routeName } from '../../../routes/routeName';
import FilterSelect from '../../../components/select/filterSelect';
import { SearchOutlined } from '@mui/icons-material';
import InputTextField from '../../../components/input/inputTextField';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { CardOnlineCourses } from '../online-course/online-courses';
import Studying from './step/studying';
import SaveCourse from './step/save-course';
import CourseSucceed from './step/course-succeed';
import Diploma from './step/diploma';

export default function MyOnlineCourse() {
    const [step, setStep] = useState<any>(0);
    const [search, setSearch] = useState<any>('')
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([{}]);
    const allStep: any[] = useMemo(() => [
        { name: t('กำลังเรียน'), isAccept: true, icon: null, disabled: false },
        { name: t('บันทึกไว้'), isAccept: true, icon: null, disabled: false },
        { name: t('สำเร็จ'), isAccept: true, icon: null, disabled: false },
        { name: t('วุฒิบัตร'), isAccept: true, icon: null, disabled: false },

    ], [t,]);
    return (
        <div>
            <ContentHeading
                title={t("คอร์สออนไลน์ของท่าน")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />
            <section style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <StepperCustom
                    // sx={{ maxWidth: "400px" }}
                    step={step}
                    setStep={(num: number) => {
                        // dispatch(setStep(num));
                        setStep(num)
                    }}
                    stepLabel={allStep}
                    view
                />
            </section>
            {step === 0 &&
                <Studying />
            }
            {step === 1 &&
                <SaveCourse />
            }
            {step === 2 &&
                <CourseSucceed />
            }
            {step === 3 &&
                <Diploma />
            }
        </div>
    )
}
